export default __webpack_public_path__ + "static/media/civic-sight.ee44c3b7.png";